import { AssignInvoiceCriteriaRepoImpl } from "domain/repository/AssignInvoiceCriteria/AssignInvoiceCriteriaRepoImpl";
import { ChargeTypeRepoImpl } from "domain/repository/ChargeType/ChargeTypeRepoImpl";
import { CompanyRepoImpl } from "domain/repository/Company/CompanyRepoImpl";
import { CustomerRepoImpl } from "domain/repository/Company/CustomerRepoImpl";
import { ParameterDetailRepoImpl } from "domain/repository/parameter/ParameterDetailRepoImpl";
import { TariffTypeRepoImpl } from "domain/repository/TariffCode/TariffTypeRepoImpl";
import { useAssignInvoiceCriteriaTracked } from "presentation/store/AssignInvoiceCriteria/AssignInvoiceCriteriaProvider";
import { AssignInvoiceCriteriaVM } from "presentation/viewModel/AssignInvoiceCriteria/AssignInvoiceCriteriaVM";
import { useMemo } from "react";

export const useAssignInvoiceCriteriaVM = () => {
    const [, setAdhocHoldOfCntrState] = useAssignInvoiceCriteriaTracked();
    const assignInvoiceCriteriaVM = useMemo(() =>
        AssignInvoiceCriteriaVM({
            dispatch: [setAdhocHoldOfCntrState],
            repo: AssignInvoiceCriteriaRepoImpl(),
            companyRepo: CompanyRepoImpl(),
            tariffTypeRepo: TariffTypeRepoImpl(),
            customerRepo: CustomerRepoImpl(),
            chargeTypeRepo: ChargeTypeRepoImpl(),
            parameterDetailRepo: ParameterDetailRepoImpl(),
        }), [setAdhocHoldOfCntrState])

    return assignInvoiceCriteriaVM
}